module.exports = __webpack_public_path__ + "public/img/default_user.1d02824a.png";